import { render, staticRenderFns } from "./TherapistDashModalAddAdministrativeTime.vue?vue&type=template&id=79c867d5&scoped=true"
import script from "./TherapistDashModalAddAdministrativeTime.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalAddAdministrativeTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c867d5",
  null
  
)

export default component.exports